import React, { forwardRef } from "react";
import { BSDiv  } from "../../types";

export const TabPane = forwardRef<HTMLDivElement, BSDiv>(
  ({ children, className = "", ...props }, ref) => {
    return (
      <div
        {...props}
        className={`tab-pane ${className} active`}
        role="tabpanel"
        ref={ref}
      >
        {children}
      </div>
    );
  }
);